import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { getUrlParams, getPushPathWrapper } from '../../routes'
import { FetchSingleApprovedAbstractAction, updateApprovedAbstractFxn } from './actions'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  issueTypeList,
  mentionsFeeds,
  NotificationBox
} from '../../components/_utils/appUtils'
import { JournalList } from '../journals/actions'

const { Option } = Select

@Form.create()
class EditAbstract extends PureComponent {
  state = {
    abstractId: false,
    journalListArr: [],
    authors: [],
    abstractFile: {},
    copyrightForm: {},
    supportingFile: {},
    fileKey: moment(),
    abstract: '',
    titleHtml: '',
    existingFiles: {}
  }

  componentDidMount() {
    this.loadJournalList()
    let data = getUrlParams('onlineAbstractsGroup.approvedEdit', this.props.pathname)
    if (data && data.id) {
      this.setState({ abstractId: data.id })
      this.setFormValuesFxn(data.id)
    }
  }

  loadJournalList = async () => {
    let { data } = await JournalList()
    this.setState({ journalListArr: data || [] })
  }

  setFormValuesFxn = async (id) => {
    const { dispatch, form: { setFieldsValue } } = this.props
    let resp = await dispatch(FetchSingleApprovedAbstractAction(id))

    if (!resp || resp.success === false || !resp.data) {
      notification.error({
        message: 'Error Loading Abstract Data'
      })
    } else {
      const record = resp.data

      // Normalize journal pointer mapping
      let journalId = record.journal
      if (journalId && typeof journalId === 'object') {
        journalId = journalId._id
      }

      setFieldsValue({
        journal: journalId,
        issueType: record.issueType,
        titleOfAbstract: record.titleOfAbstract,
        researchArea: record.researchArea,
        abstractNo: record.onlineAbstractId,
        authorName: record.authorName,
        email: record.email,
        mobile: record.mobile,
        institution: record.institution,
        designation: record.designation,
        country: record.country,
        orcidId: record.orcidId,
        keywords: record.keywords || [],
        speakerNote: record.speakerNote
      })

      this.setState({
        abstract: record.abstract || '',
        titleHtml: record.titleOfAbstract || '',
        authors: record.coAuthors || [],
        existingFiles: {
          abstractFile: record.abstractFile,
          copyrightForm: record.copyrightForm,
          supportingFile: record.supportingFile
        }
      })
    }
  }

  addMoreAuthor = () => {
    const { form: { getFieldsValue, setFieldsValue } } = this.props
    const coAuthorFields = ['coAuthorName', 'coAuthorEmail', 'coAuthorAffiliation', 'coAuthorCountry', 'coAuthorOrcid']
    const values = getFieldsValue(coAuthorFields)

    if (!values.coAuthorName || !values.coAuthorEmail || !values.coAuthorAffiliation || !values.coAuthorCountry) {
      notification.error({
        message: 'Missing Fields',
        description: 'Please populate mandatory name, email, country, and affiliation data metrics.'
      })
      return
    }

    let cloneAuthors = _.clone(this.state.authors)
    cloneAuthors.push({
      name: values.coAuthorName,
      email: values.coAuthorEmail,
      affiliation: values.coAuthorAffiliation,
      country: values.coAuthorCountry,
      orcidId: values.coAuthorOrcid
    })

    this.setState({ authors: cloneAuthors }, () => {
      setFieldsValue({
        coAuthorName: '',
        coAuthorEmail: '',
        coAuthorAffiliation: '',
        coAuthorCountry: undefined,
        coAuthorOrcid: ''
      })
    })
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const { abstractId, authors, abstract, titleHtml, abstractFile, copyrightForm, supportingFile } = this.state

        let fd = new FormData()

        // Exclude transitional co-author fields from main mapping
        const cleanValData = _.omit(valData, [
          'coAuthorName',
          'coAuthorEmail',
          'coAuthorAffiliation',
          'coAuthorCountry',
          'coAuthorOrcid'
        ])

        const payload = {
          ...cleanValData,
          abstractId: abstractId,
          coAuthors: authors,
          titleOfAbstract: valData.titleOfAbstract || titleHtml,
          abstract: abstract,
          keywords: valData.keywords || []
        }

        fd.append('obj', JSON.stringify(payload))

        if (abstractFile && abstractFile.name) fd.append('abstractFile', abstractFile)
        if (copyrightForm && copyrightForm.name) fd.append('copyrightForm', copyrightForm)
        if (supportingFile && supportingFile.name) fd.append('supportingFile', supportingFile)

        let response = await dispatch(updateApprovedAbstractFxn(fd))

        if (response && response.success) {
          NotificationBox({
            title: 'Production Abstract Updated Successfully',
            callback: () => {
              dispatch(getPushPathWrapper('onlineAbstractsGroup.submittedAbstracts'))
            }
          })
        } else {
          notification.error({
            message: response.message || 'Execution error encountered during file synchronization upload'
          })
        }
      }
    })
  }

  removeAuthorSubmit = index => {
    let cloneAuthors = _.clone(this.state.authors)
    cloneAuthors.splice(index, 1)
    this.setState({ authors: cloneAuthors })
  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  render() {
    const { form: { getFieldDecorator }, loading } = this.props
    const { journalListArr, authors, abstract, fileKey, existingFiles } = this.state

    const formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }

    // 🟢 OPTIMIZED TEXT SCHEMA: Only maps text textareas, dropdown components have been completely unboxed below
    const textInputSchema = {
      abstractFields: [
        {
          label: 'Title of Abstract',
          key: 'titleOfAbstract',
          required: true,
          type: 'text',
          placeholder: 'Enter title of your abstract',
          onChange: (e) => this.setState({ titleHtml: e.target.value })
        },
        {
          label: 'Research Area',
          key: 'researchArea',
          required: true,
          type: 'text',
          placeholder: 'Select Research Area'
        },
        { label: 'Abstract No', key: 'abstractNo', disabled: true }
      ],
      authorFields: [
        { label: 'Author Name', key: 'authorName', required: true, placeholder: 'Corresponding author full name' },
        { label: 'Email', key: 'email', required: true, placeholder: 'name@email.com' },
        { label: 'Mobile Number', key: 'mobile', required: true, placeholder: 'Enter contact phone' },
        {
          label: 'Institution / Affiliation',
          required: true,
          key: 'institution',
          placeholder: 'Enter company or university affiliate'
        },
        { label: 'ORCID ID', key: 'orcidId', placeholder: '0000-0000-0000-0000' }
      ]
    }

    const columns = [
      { title: 'Name', dataIndex: 'name', key: 'name' },
      { title: 'Affiliation', dataIndex: 'affiliation' },
      { title: 'Email', dataIndex: 'email' },
      { title: 'Country', dataIndex: 'country', key: 'country' },
      { title: 'ORCID ID', dataIndex: 'orcidId', key: 'orcidId' },
      {
        title: 'Action',
        render: (_, __, index) => (
          <Tooltip title='Remove'>
            <Button size='small' icon='close' type='danger' onClick={() => this.removeAuthorSubmit(index)} />
          </Tooltip>
        )
      }
    ]

    return (
      <PageHeaderWrapper title='Update Abstract'>
        <Card bordered={false}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark className='inputForm'>
            <Row gutter={24}>
              <Col span={12}>
                <Card title={<span><Icon type='file-text' /> 1. Abstract Information</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>

                    {/* 🟢 NATIVE DROPDOWN: Fixed freezing on change, updates screen immediately */}
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Journal / Event'>
                        {getFieldDecorator('journal', {
                          rules: [{ required: true, message: 'Please select a Journal!' }]
                        })(
                          <Select showSearch placeholder='Select Journal' optionFilterProp='children'>
                            {journalListArr.map(j => <Option key={j._id} value={j._id}>{j.name}</Option>)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>

                    {/* 🟢 NATIVE DROPDOWN: Fixed Issue type select container */}
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Issue Type'>
                        {getFieldDecorator('issueType', {
                          rules: [{ required: true, message: 'Please select an Issue Type!' }]
                        })(
                          <Select placeholder='Select Issue Type'>
                            {issueTypeList.map(i => <Option key={i.value || i}
                                                            value={i.value || i}>{i.text || i}</Option>)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>

                    {textInputSchema.abstractFields.map((item, key) => (
                      <Col span={12} key={key}>
                        <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
                                           formItemLayout={formItemLayout} />
                      </Col>
                    ))}

                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Keywords (up to 6) *'>
                        {getFieldDecorator('keywords', {
                          rules: [{ required: true, message: 'Please enter keywords!' }]
                        })(
                          <Select mode='tags' style={{ width: '100%' }} placeholder='Add keyword'
                                  tokenSeparators={[',']} dropdownStyle={{ display: 'none' }} />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                <Card title={<span><Icon type='edit' /> 2. Abstract Content & Files</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>
                    <Col span={24}>
                      <InputBox title='Abstract Content*'>
                        <CustomCkEditor feeds={mentionsFeeds} html={abstract} placeholder='Write your abstract here...'
                                        onChange={data => this.setState({ abstract: data })} />
                      </InputBox>
                    </Col>
                    <Col span={24} style={{ marginTop: 20 }}>
                      <Row gutter={8}>
                        <Col span={8}>
                          <InputBox title='Abstract File' className='rowFlex'>
                            <Input type='file' name='abstractFile' key={fileKey} onChange={this.chooseDocument} />
                            {existingFiles.abstractFile && existingFiles.abstractFile.path && (
                              <a className='linkBtn' target='_blank' rel='noopener noreferrer'
                                 href={existingFiles.abstractFile.path} style={{ marginLeft: 5 }}><Icon
                                type='eye' /></a>
                            )}
                          </InputBox>
                        </Col>
                        <Col span={8}>
                          {/*<InputBox title="Copyright Form" className="rowFlex">*/}
                          {/*  <Input type="file" name="copyrightForm" key={fileKey} onChange={this.chooseDocument} />*/}
                          {/*  {existingFiles.copyrightForm && existingFiles.copyrightForm.path && (*/}
                          {/*    <a className="linkBtn" target="_blank" rel="noopener noreferrer" href={existingFiles.copyrightForm.path} style={{marginLeft: 5}}><Icon type="eye" /></a>*/}
                          {/*  )}*/}
                          {/*</InputBox>*/}
                        </Col>
                        <Col span={8}>
                          {/*<InputBox title="Supporting File" className="rowFlex">*/}
                          {/*  <Input type="file" name="supportingFile" key={fileKey} onChange={this.chooseDocument} />*/}
                          {/*  {existingFiles.supportingFile && existingFiles.supportingFile.path && (*/}
                          {/*    <a className="linkBtn" target="_blank" rel="noopener noreferrer" href={existingFiles.supportingFile.path} style={{marginLeft: 5}}><Icon type="eye" /></a>*/}
                          {/*  )}*/}
                          {/*</InputBox>*/}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>

                <Card title={<span><Icon type='message' /> 3. Speaker Note</span>} bordered={true}>
                  <GetEachFormFields
                    item={{
                      label: 'Short Biography / Speaker Note',
                      key: 'speakerNote',
                      type: 'textArea',
                      placeholder: 'Brief bio or speaker note',
                      rows: 4
                    }}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout}
                  />
                </Card>
              </Col>

              <Col span={12}>
                <Card title={<span><Icon type='user' /> 4. Corresponding Author Details</span>} bordered={true}
                      style={{ marginBottom: '24px' }}>
                  <Row gutter={16}>
                    {textInputSchema.authorFields.map((item, key) => (
                      <Col span={12} key={key}>
                        <GetEachFormFields item={item} getFieldDecorator={getFieldDecorator}
                                           formItemLayout={formItemLayout} />
                      </Col>
                    ))}

                    {/* 🟢 NATIVE DROPDOWN: Fixed Author Designation selector */}
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Designation'>
                        {getFieldDecorator('designation', {
                          rules: [{ required: true, message: 'Please select a Designation!' }]
                        })(
                          <Select placeholder='Select Designation'>
                            {DesignationList.map(d => <Option key={d.value || d}
                                                              value={d.value || d}>{d.text || d}</Option>)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>

                    {/* 🟢 NATIVE DROPDOWN: Fixed Author Country selector */}
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Select Country'>
                        {getFieldDecorator('country', {
                          rules: [{ required: true, message: 'Please select a Country!' }]
                        })(
                          <Select showSearch placeholder='Select Country' optionFilterProp='children'>
                            {Countries.map(c => <Option key={c.name} value={c.name}>{c.name}</Option>)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                <Card title={<span><Icon type='team' /> 5. Co-authors</span>} bordered={true}>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Full Name *'>
                        {getFieldDecorator('coAuthorName')(
                          <Input placeholder='Enter name' />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Email *'>
                        {getFieldDecorator('coAuthorEmail')(
                          <Input placeholder='name@email.com' />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Affiliation *'>
                        {getFieldDecorator('coAuthorAffiliation')(
                          <Input placeholder='Enter affiliation' />
                        )}
                      </Form.Item>
                    </Col>

                    {/* Co-author Country Dropdown rendered natively to complete UI overhaul */}
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='Select Country *'>
                        {getFieldDecorator('coAuthorCountry')(
                          <Select showSearch placeholder='Select Country' optionFilterProp='children'>
                            {Countries.map(c => <Option key={c.name} value={c.name}>{c.name}</Option>)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item {...formItemLayout} label='ORCID ID'>
                        {getFieldDecorator('coAuthorOrcid')(
                          <Input placeholder='0000-0000-0000-0000' />
                        )}
                      </Form.Item>
                    </Col>

                    <Col span={24} style={{ marginTop: 10 }}>
                      <Button onClick={this.addMoreAuthor} type='primary' ghost block><Icon type='plus' /> Add Co-Author
                        to List</Button>
                      <Table columns={columns} dataSource={authors} pagination={false} size='small' bordered
                             style={{ marginTop: 15 }} rowKey={(r, i) => i} />
                    </Col>
                  </Row>
                </Card>
              </Col>

              <Col span={24} style={{ textAlign: 'left', marginTop: '32px' }}>
                <Form.Item>
                  <Button type='primary' htmlType='submit' size='medium' loading={loading}>
                    SAVE CHANGES
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  pathname: router && router.location ? router.location.pathname : window.location.pathname
})

export default connect(mapStateToProps)(EditAbstract)
